module.exports = __webpack_public_path__ + "img/spacex.aea59c85.webp";